export default "__VITE_ASSET__BSJhuG3Q__"